// import { CustomError } from './ErrorMappers';
import ASYNC_STATUS from '../constants/async/statuses';
// import { errorAsyncCtechApi, errorAsyncCuotitasApi } from '../constants/errors/examples';

// eslint-disable-next-line no-unused-vars
const postSelfieSuccessResponse = {
    "message": "Task with id: 9926c9e1-4e0e-4da2-9884-f4c0e2ef567a",
    "task": {
        "id": "9926c9e1-4e0e-4da2-9884-f4c0e2ef567a",
        "status": {
            "id": 3,
            "description": "FINISHED"
        },
        "result": {
            "id": 408053,
            "id_token_type": 1,
            "description": "",
            "refresh_token": "6HuJg8yvRPQOuOx9LfyxMxl7qrZAYTg2z9oIDaV9vIeGhgGrH6RtQXjqPZdlvXJj",
            "metadata": {
                "exp": 1686752420.649,
                "iat": 1686752120.649,
                "jti": 408053,
                "sub": 10169,
                "idPlatform": 5
            },
            "refresh_expires_at": "2023-07-14T14:15:20.000Z",
            "expires_at": "2023-06-14T14:20:20.000Z",
            "created_at": "2023-06-14T14:15:20.000Z",
            "updated_at": "2023-06-14T14:15:20.000Z",
            "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2ODY3NTI0MjAuNjQ5LCJpYXQiOjE2ODY3NTIxMjAuNjQ5LCJqdGkiOjQwODA1Mywic3ViIjoxMDE2OSwiaWRQbGF0Zm9ybSI6NSwiaXNzIjoidG9rZW5zLmZpbnRlY2guY29tIn0.pn3Mw-4KRC5gzY9zHS4LmVTc_JD-qrzSv7gGyIBriAM"
        }
    }
}
// eslint-disable-next-line no-unused-vars
const postSelfieErrorResponse = {
    "message": "Task with id: 4c6cfa97-b0c5-4f59-a01b-af84cebc630b",
    "task": {
        "id": "4c6cfa97-b0c5-4f59-a01b-af84cebc630b",
        "status": {
            "id": 3,
            "description": "FINISHED"
        },
        "result": {
            "error": "Rekognition: Selfies do not correspond to the requested gesture.",
            "code": 406,
            "extra": {
                "key": "gesture_validation_failed",
                "hash": "aHCtuhG9mdvj0Ez",
                "idCuotitasRequest": 857,
                "code": 64052001,
                "message": "Rekognition. No se superó la validación de gesto sonrisa (SS).",
                "trace": "iHRxjV",
                "from": "signs",
                "path": "/signs/cuotitas/login",
                "method": "POST"
            },
            "name": "NotAcceptable"
        }
    }
}
// eslint-disable-next-line no-unused-vars
const postDocumentResponse = {
    "id": 4306,
    "id_cuotitas_request": 836,
    "id_file": 14823,
    "signed": 0,
    "active": 1,
    "informative": 0,
    "created_at": "2023-06-14T16:19:11.000Z",
    "updated_at": null
}

/**
 * Asynchronous call to avoid time out
 * @param {Promise} service it has to be (qs) => service(qs)
 * @param {Integer} time in miliseconds, default 3000
 * @returns response
 */
export const asyncService = async (service, time = 3000) => {
    const qs = {
        async: true// id de la proxima pregunta
    };
    // let response = errorAsyncCuotitasApi;
    // let response = errorAsyncCtechApi;
    let response = await service(qs);
    // Example of response
    // let response = postSelfieErrorResponse;
    // let response = postSelfieSuccessResponse;

    qs.async = response?.task?.id;// id de la proxima pregunta

    // We check if response is ready to use
    while (response?.task?.status?.id === ASYNC_STATUS.awaiting) {
        await sleep(time);
        // response = postSelfieSuccessResponse;
        response = await service(qs);
    };

    const responseSuccess = !("error" in response?.task?.result);
    // Check if it response has error?
    if (response?.task?.status?.id === ASYNC_STATUS.error || (response?.task?.status?.id && !responseSuccess) || response?.task?.result?.code >= 400) {
        throw new CustomError(response?.task?.result);
    }

    return response?.task?.result || response;
};

/**
 * Simulate an asynchronous call
 * @param {Integer} ms time to wait in miliseconds
 * @returns void
 */
export function sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Simulates delay
 */
export function delay (milliseconds) {
    const start = new Date().getTime();
    for (let i = 0; i < 1e7; i++) {
        if ((new Date().getTime() - start) > milliseconds) {
            break;
        }
    }
}

/**
 * Custom error that can return objects
 */
export class CustomError extends Error {
    constructor (message) {
        super(JSON.stringify(message));
        this.name = this.constructor.name;
        this.response = {
            data: JSON.parse(this.message)
        };
        // this.code = code;
        // this.extra = extra;
        // Error.captureStackTrace(this, this.constructor);
    }

    from () {
        return JSON.parse(this.message);
    }
}